import { Box, Grid, Stack } from "@mui/material";
import { SLTypography } from "components/slTypography";
import {
  SoulBenefitsImage,
  TickWithCircleBorder,
} from "helpers/enum/constants";

const SoulBenefits = () => (
  <>
    <Box>
      <Grid container>
        <Grid item lg={7}>
          <Stack>
            <SLTypography
              variant="heading"
              sx={{
                color: "var(--sl-deep-purple)",
                letterSpacing: "-.3px",
                fontSize: { xs: "19px", sm: "27px" },
              }}
              tabIndex={0}
              role="heading"
            >
              The Benefits of Soul Link
            </SLTypography>
            <SLTypography
              tabIndex={0}
              variant="smallBody"
              sx={{
                paddingTop: "15px",
                fontSize: { xs: "17px", sm: "20px" },
                fontWeight: "500",
                color: "var(--sl-deep-purple)",
              }}
            >
              Soul Link supports alignment between your mental, physical, and
              emotional well-being, offering a noninvasive approach to fostering
              greater balance and vitality.
              <br />
              <br />
              As your brain and body respond to carefully formulated sound and
              visual experiences, you may notice a sense of physical ease,
              enhanced internal balance, and greater emotional stability.
              <br />
              <br />
              By working with the body’s natural rhythms and promoting internal
              balance, Soul Link helps support physical adaptability, emotional
              regulation, and an overall sense of well-being. Encouraging a more
              present, grounded, and aligned state of mind and body.
            </SLTypography>
          </Stack>
          <Stack
            sx={{ paddingTop: "32px", paddingRight: "20px" }}
            spacing="21px"
          >
            <Box sx={{ display: "flex", gap: "12px" }}>
              <Box
                component="img"
                sx={{
                  height: "24px",
                  width: "24px",
                }}
                alt="/"
                src={TickWithCircleBorder}
              />
              <SLTypography
                tabIndex={0}
                variant="smallBody"
                sx={{ color: "var(--sl-deep-purple)" }}
              >
                Soul Link for Stress Regulation – Support a calmer nervous
                system with sound and video experiences designed to encourage
                autonomic regulation, facilitate relaxation responses, and
                foster neurophysiological adaptability.
              </SLTypography>
            </Box>
            <Box sx={{ display: "flex", gap: "12px" }}>
              <Box
                component="img"
                sx={{
                  height: "24px",
                  width: "24px",
                }}
                alt="/"
                src={TickWithCircleBorder}
              />
              <SLTypography
                tabIndex={0}
                variant="smallBody"
                sx={{ color: "var(--sl-deep-purple)" }}
              >
                Soul Link for Sleep Support – Encourage healthier sleep patterns
                using calming audio-visual tools that support relaxation
                responses, promote autonomic regulation, and facilitate the
                body's natural transition into restful states.
              </SLTypography>
            </Box>
            <Box sx={{ display: "flex", gap: "12px" }}>
              <Box
                component="img"
                sx={{
                  height: "24px",
                  width: "24px",
                }}
                alt="/"
                src={TickWithCircleBorder}
              />
              <SLTypography
                tabIndex={0}
                variant="smallBody"
                sx={{ color: "var(--sl-deep-purple)" }}
              >
                Soul Link for Physical Comfort – Support the body's natural
                relaxation responses with noninvasive sound-based wellness
                techniques paired with visual input to encourage muscular
                relaxation, promote sensory integration, and foster overall
                physical well-being.
              </SLTypography>
            </Box>
            <Box sx={{ display: "flex", gap: "12px" }}>
              <Box
                component="img"
                sx={{
                  height: "24px",
                  width: "24px",
                }}
                alt="/"
                src={TickWithCircleBorder}
              />
              <SLTypography
                tabIndex={0}
                variant="smallBody"
                sx={{ color: "var(--sl-deep-purple)" }}
              >
                Soul Link for Emotional Stability – Strengthen emotional
                resilience and support adaptive emotional responses with
                scientifically designed sound and video inputs that encourage
                self-regulation, promote neural coherence, and foster a sense of
                internal harmony.
              </SLTypography>
            </Box>
            <Box sx={{ display: "flex", gap: "12px" }}>
              <Box
                component="img"
                sx={{
                  height: "24px",
                  width: "24px",
                }}
                alt="/"
                src={TickWithCircleBorder}
              />
              <SLTypography
                tabIndex={0}
                variant="smallBody"
                sx={{ color: "var(--sl-deep-purple)" }}
              >
                Soul Link for Attention & Clarity – Enhance cognitive engagement
                and attentional control with sound-based methodologies designed
                to encourage neural responsiveness, facilitate sensory
                integration, and promote mental agility.
              </SLTypography>
            </Box>
            <Box sx={{ display: "flex", gap: "12px" }}>
              <Box
                component="img"
                sx={{
                  height: "24px",
                  width: "24px",
                }}
                alt="/"
                src={TickWithCircleBorder}
              />
              <SLTypography
                tabIndex={0}
                variant="smallBody"
                sx={{ color: "var(--sl-deep-purple)" }}
              >
                Soul Link for Daily Wellness & Recovery Support – Incorporate
                Soul Link into your routine as a noninvasive tool designed to
                support neurophysiological resilience, encourage autonomic
                regulation, and facilitate adaptive recovery processes essential
                for maintaining overall mental and physical well-being.
              </SLTypography>
            </Box>
            <Box sx={{ display: "flex", gap: "12px" }}>
              <Box
                component="img"
                sx={{
                  height: "24px",
                  width: "24px",
                }}
                alt="/"
                src={TickWithCircleBorder}
              />
              <SLTypography
                tabIndex={0}
                variant="smallBody"
                sx={{ color: "var(--sl-deep-purple)" }}
              >
                Soul Link for Cognitive Support – Utilize research-informed
                frequencies and structured video stimulation to encourage
                neuroadaptive engagement, facilitate cognitive processing, and
                promote attentional resilience.
              </SLTypography>
            </Box>
            <Box sx={{ display: "flex", gap: "12px" }}>
              <Box
                component="img"
                sx={{
                  height: "24px",
                  width: "24px",
                }}
                alt="/"
                src={TickWithCircleBorder}
              />
              <SLTypography
                tabIndex={0}
                variant="smallBody"
                sx={{ color: "var(--sl-deep-purple)" }}
              >
                Soul Link for Personal Resilience – Support psychological
                adaptability and cognitive flexibility through consistent
                exposure to structured sound and visual experiences designed to
                foster neuroadaptive resilience and emotional self-regulation.
              </SLTypography>
            </Box>
          </Stack>
        </Grid>
        <Grid item lg={1} />
        <Grid
          item
          lg={4}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: { xs: "30px" },
            backgroundRepeat: "no-repeat",
            borderRadius: "10px",
            background: `url(${SoulBenefitsImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      </Grid>
    </Box>
  </>
);

export default SoulBenefits;
